import { createApp } from 'vue/dist/vue.esm-bundler';

createApp({
    data() {
        return {
        	tops: [],
            lowers: [],
            layers: [],
            accessories: [],
            mobile_branch: [],
            mobile_branch_other: "",
            maternity: [],
            maternity_other: "",
            cultural: [],
            cultural31: "",
            cultural41: "",
            cultural51: "",
            cultural_other: "",
            uniform_design: "",
            uniform_design_why: "",
            unfirom_comfort: "",
            unfirom_comfort_why: "",
            uniform_fit: "",
            unform_fit_why: "",
            uniform_balance: "",
            uniform_balance_info: "",
            uniform_ordering: "",
            uniform_ordering_why: "",
            seasonal_options: "",
            seasonal_options_missing: "",
            inclusive: "",
            improvements: "",
            uniform_hub_useful: "",
            uniform_hub_improvements: "",
            customer_feedback: "",
            customer_feedback_info: ""
        }
    },
    methods: {
        submitForm:function(){

            let vm = this;

            if( this.tops.length <= 0 && this.lowers.length <= 0 && this.layers.length <= 0 && this.accessories.length <= 0 ){

                Swal.fire({
                    title: "Error",
                    text: "For question 1 please select at least one option from either 'Tops', 'Lowers/Dress', 'Layers' or 'Accessories'.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( this.cultural.includes("Turban MalMal Fabric Black and in which length?") && isEmpty( this.cultural31 ) || this.cultural.includes("Turban Voile Fabric Black and in which length?") && isEmpty( this.cultural41 ) || this.cultural.includes("Turban Voile Fabric Navy and in which length?") && isEmpty( this.cultural51 ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select the length for your cultural uniform selection",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.uniform_design ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 2.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( ( this.uniform_design == "Poor" || this.uniform_design == "Very Poor" ) && isEmpty( this.uniform_design_why ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please explain why for question 2.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.unfirom_comfort ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 3.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( ( this.unfirom_comfort == "Poor" || this.unfirom_comfort == "Very Poor" ) && isEmpty( this.unfirom_comfort_why ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please explain why for question 3.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.uniform_fit ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 4.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( ( this.uniform_fit == "Poor" || this.uniform_fit == "Very Poor" ) && isEmpty( this.unform_fit_why ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please explain why for question 4.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.uniform_balance ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 5.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( this.uniform_balance == "Could be improved, please expand further?" && isEmpty( this.uniform_balance_info ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please enter how the uniform could be improved, for question 5.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.uniform_ordering ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 6.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( ( this.uniform_ordering == "Difficult" || this.uniform_ordering == "Very Difficult" ) && isEmpty( this.uniform_ordering_why ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please explain why for question 6.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.seasonal_options ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 7.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( this.seasonal_options == "Yes" && isEmpty( this.seasonal_options_missing ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please enter what styles are missing, for question 7.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.inclusive ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 8.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.improvements ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please enter an answer for question 9.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.uniform_hub_useful ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 10.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( this.uniform_hub_useful == "No: it could be improved" && isEmpty( this.uniform_hub_improvements ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please enter how can we improve the information, for question 10.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( isEmpty( this.customer_feedback ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please select an answer for question 11.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            if( this.customer_feedback == "Yes" && isEmpty( this.customer_feedback_info ) ){

                Swal.fire({
                    title: "Error",
                    text: "Please expand further for question 11.",
                    icon: "error",
                    confirmButtonColor: "#3c1053"
                });
                return;
            }

            $('#processing').fadeIn();

            grecaptcha.ready(function() {
                grecaptcha.execute('6LcvvdMqAAAAAP3F4oE5oVPVjxuxJD6QHwogHKbb', {action: 'submit'}).then(function(token) {
                    
                    $.ajax({
                        type:"POST",
                        url:"/wp-json/titanpress/v1/recaptcha-verify",
                        data:{
                            token:token
                        },
                        headers:{
                            'x-wwug-header': 'wwug'
                        },
                        success: function( response ){

                            let captcha = JSON.parse( response );

                            if( captcha.success === true ){

                                if( captcha.score >= 0.5 ){

                                    vm.sendForm();
                                }
                                else{

                                    Swal.fire({
                                        title: "Error",
                                        text: "Sorry Google RECAPTCHA has scored you low and blocked your submission. Please contact us.",
                                        icon: "error"
                                    });

                                    $('#processing').fadeOut();
                                }
                            }
                            else{

                                Swal.fire({
                                    title: "Error",
                                    text: "Sorry and error has occured verifying you with Google RECAPTCHA, please contact us.",
                                    icon: "error"
                                });

                                $('#processing').fadeOut();
                            }
                        },
                        error: function(){

                            Swal.fire({
                                title: "Error",
                                text: "Sorry and error has occured trying to verify you with Google RECAPTCHA, please contact us.",
                                icon: "error"
                            });

                            $('#processing').fadeOut();
                        }
                    });
                });
            });
        },
        sendForm(){

            $.ajax({
                type:"POST",
                url:"/wp-json/titanpress/v1/send-survey",
                headers:{
                    'x-wwug-header': 'wwug'
                },
                data:{
                    action:'save_survey',
                    tops: this.tops,
                    lowers: this.lowers,
                    layers: this.layers,
                    accessories: this.accessories,
                    mobile_branch: this.mobile_branch,
                    mobile_branch_other: this.mobile_branch_other,
                    maternity: this.maternity,
                    maternity_other: this.maternity_other,
                    cultural: this.cultural,
                    cultural31: this.cultural31,
                    cultural41: this.cultural41,
                    cultural51: this.cultural51,
                    cultural_other: this.cultural_other,
                    uniform_design: this.uniform_design,
                    uniform_design_why: this.uniform_design_why,
                    unfirom_comfort: this.unfirom_comfort,
                    unfirom_comfort_why: this.unfirom_comfort_why,
                    uniform_fit: this.uniform_fit,
                    unform_fit_why: this.unform_fit_why,
                    uniform_balance: this.uniform_balance,
                    uniform_balance_info: this.uniform_balance_info,
                    uniform_ordering: this.uniform_ordering,
                    uniform_ordering_why: this.uniform_ordering_why,
                    seasonal_options: this.seasonal_options,
                    seasonal_options_missing: this.seasonal_options_missing,
                    inclusive: this.inclusive,
                    improvements: this.improvements,
                    uniform_hub_useful: this.uniform_hub_useful,
                    uniform_hub_improvements: this.uniform_hub_improvements,
                    customer_feedback: this.customer_feedback,
                    customer_feedback_info: this.customer_feedback_info
                },
                success:function( response ){

                    $('#processing').fadeOut();

                    if( response !== false ){

                        Swal.fire({
                            title: "Thank you!",
                            text: "We have successfully received your feedback.",
                            icon: "success"
                        });
                    }
                },
                error:function(){

                    Swal.fire({
                        title: "Error",
                        text: "Sorry and error has occured sending your feedback, please contact us.",
                        icon: "error"
                    });

                    $('#processing').fadeOut();
                }
            });
        }
    },
    watch: {

    },
    mounted() {

    },
    template: ''
}).mount('#survey-form');

function isEmpty(str){
    return (!str || 0 === str.length || str.length === 0 || !str.trim());
}